export default "__VITE_ASSET__C0J2ypRu__"